import { Loader2, Bitcoin, Coins } from "lucide-react";

export function CartSummary({ items, subtotal, promo, discountedTotal, step, onContinue, onCheckout, onCrypto, cryptoEnabled, loading, canProceed }) {
  const busy = loading !== false;
  return (
    <div className="border-t border-white/5 px-6 py-4 sm:py-5 space-y-2.5 sm:space-y-3 pb-[max(1rem,env(safe-area-inset-bottom))]">
      <div className="flex items-center justify-between">
        <div className="bl-eyebrow">Subtotal</div>
        <div className="font-mono text-white">A${subtotal.toFixed(2)}</div>
      </div>
      {promo && (
        <div className="flex items-center justify-between text-[color:var(--bl-green)]">
          <div className="font-mono text-[10px] tracking-[0.25em] uppercase">{promo.label}</div>
          <div className="font-mono">−A${(subtotal - discountedTotal).toFixed(2)}</div>
        </div>
      )}
      <div className="flex items-center justify-between">
        <div className="bl-eyebrow">Total</div>
        <div className="font-display text-xl">A${discountedTotal.toFixed(2)}</div>
      </div>
      <div className="hidden sm:flex items-center justify-between font-mono text-[10px] tracking-[0.25em] uppercase text-white/40">
        <span>Total Vials</span><span>{items.reduce((s, i) => s + i.quantity * (i.vials_per_unit ?? 10), 0)}</span>
      </div>
      {step === "cart" ? (
        <button onClick={onContinue} data-testid="cart-goto-address" className="w-full bl-btn primary">Continue to Shipping</button>
      ) : (
        <div className="space-y-2">
          <button onClick={onCheckout} disabled={busy || !canProceed} data-testid="cart-checkout-btn" className="w-full bl-btn primary disabled:opacity-40 inline-flex items-center justify-center gap-2">
            {loading === "manual" ? <><Loader2 size={14} className="animate-spin" /> Placing order</> : <><Coins size={14} /> {cryptoEnabled ? "Place Order · Crypto Invoice by Email" : "Place Order · Pay by Crypto"}</>}
          </button>
          <div data-testid="cart-payment-note" className="font-mono text-[9px] tracking-[0.2em] uppercase text-white/40 text-center pt-1">
            Crypto only · Bitcoin &amp; USDT · no cards or bank payments
          </div>
          {cryptoEnabled && (
            <button onClick={onCrypto} disabled={busy || !canProceed} data-testid="cart-crypto-btn" className="w-full bl-btn gold disabled:opacity-40 inline-flex items-center justify-center gap-2">
              {loading === "crypto" ? <><Loader2 size={14} className="animate-spin" /> Creating invoice</> : <><Bitcoin size={14} /> Pay with Bitcoin now</>}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
